<template>
  <div class="file-single">
    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        value="..."
        readonly
        :placeholder="$t('message.contracts.document_number')"
        autocomplete="off"
        style="cursor: auto"
        id="document_number"
      />
      <label for="document_number" class="form-label-group-label shorter">{{
        $t("message.contracts.document_number")
      }}</label>
    </span>
    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <!-- <b-form-datepicker :locale="locale" v-model="document_.attis_contract_doc_date" :placeholder="$t('message.contracts.document_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="document_date"></b-form-datepicker>
			<label  v-if="document_.attis_contract_doc_date!=''"  for="document_date" class="form-label-group-label shorter topped">{{$t('message.contracts.document_date')}}</label> -->

      <datepicker
        value-type="YYYY-MM-DD"
        format="DD.MM.YYYY"
        @focus="document_.attis_contract_doc_date = ' '"
        @blur="
          document_.attis_contract_doc_date == ' '
            ? (document_.attis_contract_doc_date = '')
            : (document_.attis_contract_doc_date =
                document_.attis_contract_doc_date)
        "
        inputClass="form-control"
        v-model="document_.attis_contract_doc_date"
        :placeholder="$t('message.contracts.document_date')"
        :inputAttr="{ id: 'document_date' }"
      />
      <label
        for="document_date"
        class="form-label-group-label shorter"
        :class="
          document_.attis_contract_doc_date != '' &&
          document_.attis_contract_doc_date != null
            ? 'topped'
            : ''
        "
        >{{ $t("message.contracts.document_date") }}</label
      >
    </span>
    <span
      :class="[
        'bmd-form-group mb-2 d-block form-label-group',
        document_types_focused ? 'focused' : '',
      ]"
    >
      <v-select-popup
        :indata="filtered_document_types"
        :placeholder="$t('message.contracts.document_types')"
        v-model="document_.attis_contract_doc_type"
      />
      <!-- <v-select id="document_types" :options="document_types" label="display_text" :class="['form-control', document_.document_type!==''?'vs--selected':'']" v-model="document_.attis_contract_doc_type" :placeholder="$t('message.contracts.document_types')" @focus="docTypeFocused" @blur="docTypeBlurred"></v-select>
			<label for="document_types" class="form-label-group-label shorter">{{$t('message.contracts.document_types')}}</label> -->
    </span>
    <span
      :class="['bmd-form-group mb-2 d-block form-label-group']"
      v-if="document_.file != ''"
    >
      {{ $t("message.contracts.document_file") }}:
      <a :href="document_.file">{{ document_.file.name }}</a>
      <button class="btn btn-link text-danger btn-sm" @click="removeFile()">
        <i class="fa fa-trash"></i>
      </button>
    </span>
    <!-- <span :class="['bmd-form-group mb-2 d-block form-label-group']" v-if="document_.file=='' && document_.attis_contract_doc_type.value!='packaging'">
			<input type="file" disabled class="form-control" :placeholder="$t('message.contracts.document_file')" autocomplete="off" style="cursor: auto;" id="document_file" @change="fileSelected($event)">
			<label for="document_file" class="form-label-group-label shorter pb-0">{{$t('message.contracts.document_file')}}</label>
			<div>
				<small>{{$t('message.can_add_file_after_saving')}}</small>
			</div>
		</span> -->
    <div class="row" v-for="(file, index) in files" :key="'lnk' + index">
      <div class="col-11">
        <a :href="file_link(file)" target="_blank" rel="noopener noreferrer"
          ><i class="fas fa-arrow-down"></i> {{ file.Name }}</a
        >
      </div>
      <div class="col-1">
        <button
          class="btn btn-sm btn-link text-danger"
          @click="removeFileUploaded(index)"
        >
          &times;
        </button>
      </div>
    </div>
    <div v-for="(file, index) in files_att" class="row" :key="'upl' + index">
      <div class="col-11">
        <input
          :disabled="files_loading"
          type="file"
          @change="attachFile($event, index)"
          class="mb-2"
        />
      </div>
      <div class="col-1">
        <button
          class="btn btn-sm btn-link text-danger"
          @click="removeFile1(index)"
        >
          &times;
        </button>
      </div>
    </div>
    <div>
      <div v-if="files_loading">{{ $t("message.wait") }}</div>
      <div v-else class="d-flex justify-space-between mt-2">
        <button
          :disabled="files_loading"
          class="btn btn-sm btn-outline-success"
          @click="addAttachement"
        >
          {{ $t("message.contracts.add_attachement") }}
        </button>
        <button
          :disabled="files_loading"
          class="btn btn-sm btn-success ml-2"
          v-if="files_att.length > 0"
          @click="upload_files"
        >
          {{ $t("message.contracts.upload") }}
        </button>
      </div>
      <br />
      <!-- <small><i>{{$t('message.contracts.add_attachement_info')}}</i></small> -->
    </div>
    <div class="text-center mt-4" v-if="loading">
      <img src="tenor.gif" alt="" />
      <div>{{ $t("message.wait") }}</div>
    </div>
    <form-invoice
      v-if="document_.attis_contract_doc_type.value == 'invoice'"
      :is_new="true"
      :goods="goods"
      :contract_details="contract_details"
      document_id="new"
      :document="document_"
      :files="files"
    >
    </form-invoice>
    <form-cmr
      v-if="document_.attis_contract_doc_type.value == 'cmr'"
      :goods="goods"
      :is_new="true"
      :contract_details="contract_details"
      document_id="new"
      :document="document_"
      :files="files"
    ></form-cmr>
    <form-fm1
      v-if="document_.attis_contract_doc_type.value == 'fm1'"
      :goods="goods"
      :is_new="true"
      :contract_details="contract_details"
      document_id="new"
      :document="document_"
      :files="files"
    ></form-fm1>
    <form-epi
      v-if="document_.attis_contract_doc_type.value == 'epi'"
      :goods="goods"
      :is_new="true"
      :contract_details="contract_details"
      document_id="new"
      :document="document_"
      :files="files"
    ></form-epi>
    <form-awb
      v-if="document_.attis_contract_doc_type.value == 'awb'"
      :goods="goods"
      :is_new="true"
      :contract_details="contract_details"
      document_id="new"
      :document="document_"
      :files="files"
    ></form-awb>
    <form-rwb
      v-if="document_.attis_contract_doc_type.value == 'rwb'"
      :goods="goods"
      :is_new="true"
      :contract_details="contract_details"
      document_id="new"
      :document="document_"
      :files="files"
    ></form-rwb>
    <form-insurance
      v-if="document_.attis_contract_doc_type.value == 'insurance'"
      :goods="goods"
      :is_new="true"
      :contract_details="contract_details"
      document_id="new"
      :document="document_"
      :files="files"
    ></form-insurance>
    <form-liability-insurance
      v-if="document_.attis_contract_doc_type.value == 'liability-insurance'"
      :goods="goods"
      :is_new="true"
      :contract_details="contract_details"
      document_id="new"
      :document="document_"
      :files="files"
    ></form-liability-insurance>
    <form-packaging
      v-if="document_.attis_contract_doc_type.value == 'packaging'"
      :goods="goods"
      :is_new="true"
      :contract_details="contract_details"
      document_id="new"
      :document="document_"
      :files="files"
    ></form-packaging>

    <form-sad
      v-if="document_.attis_contract_doc_type.value == 'sad'"
      :goods="goods"
      :is_new="true"
      :contract_details="contract_details"
      document_id="new"
      :document="document_"
      :files="files"
    ></form-sad>
    <form-ktg-attorney
      v-if="document_.attis_contract_doc_type.value == 'ktg_attorney'"
      :goods="goods"
      :is_new="true"
      :contract_details="contract_details"
      document_id="new"
      :document="document_"
      :files="files"
    ></form-ktg-attorney>

    <form-specification
      v-if="document_.attis_contract_doc_type.value == 'specification'"
      :goods="goods"
      :is_new="true"
      :contract_details="contract_details"
      document_id="new"
      :document="document_"
      :files="files"
    ></form-specification>

    <br /><br />
    <button
      class="btn btn-success"
      @click="saveDocument()"
      v-if="
        typeof document_.attis_contract_doc_type !== 'undefined' &&
        document_.attis_contract_doc_type.value !== 'epi' &&
        document_.attis_contract_doc_type.value !== 'fm1' &&
        document_.attis_contract_doc_type.value !== 'invoice' &&
        document_.attis_contract_doc_type.value !== 'cmr' &&
        document_.attis_contract_doc_type.value !== 'awb' &&
        document_.attis_contract_doc_type.value !== 'rwb' &&
        document_.attis_contract_doc_type.value !== 'packaging' &&
        document_.attis_contract_doc_type.value !== 'insurance' &&
        document_.attis_contract_doc_type.value !== 'sad' &&
        document_.attis_contract_doc_type.value !== 'liability-insurance' &&
        document_.attis_contract_doc_type.value !== 'ktg_attorney' &&
        document_.attis_contract_doc_type.value !== 'specification'
      "
      :disabled="loading"
    >
      {{ $t("message.contracts.document_create") }}
    </button>
    <button
      class="btn btn-outline-danger float-right btn-sm"
      @click="cancel()"
      style="bottom: 16px; position: absolute; right: 20px"
      :disabled="loading"
    >
      {{ $t("message.cancel") }}
    </button>
  </div>
</template>
<script>
import formPackaging from "../contracts/form-packaging.vue";
export default {
  name: "file-new",
  components: { formPackaging },
  props: ["goods", "contract_details"],
  data() {
    return {
      loading: false,
      navigation_name: "",
      files_att: [],
      files: [],
      documents: [],
      files_loading: false,
      document_: {
        attis_contract_doc_number: "",
        attis_contract_doc_date: "",
        attis_contract_doc_type: { value: "", display_text: "" },
        file: "",
      },
      document_types_focused: false,
      document_types: [
        {
          value: "invoice",
          display_text: this.$t("message.contracts.document_invoice"),
        },
        {
          value: "cmr",
          display_text: this.$t("message.contracts.document_cmr"),
        },
        {
          value: "fm1",
          display_text: this.$t("message.contracts.document_fm1"),
        },
        {
          value: "epi",
          display_text: this.$t("message.contracts.document_epi"),
        },
        {
          value: "awb",
          display_text: this.$t("message.contracts.document_awb"),
        },
        {
          value: "rwb",
          display_text: this.$t("message.contracts.document_rwb"),
        },
        {
          value: "insurance",
          display_text: this.$t("message.contracts.document_insurance"),
        },
        {
          value: "liability-insurance",
          display_text: this.$t(
            "message.contracts.document_liability_insurance",
          ),
        },
        {
          value: "packaging",
          display_text: this.$t("message.contracts.document_packaging"),
        },
        {
          value: "sad",
          display_text: this.$t("message.contracts.document_sad"),
        },
        {
          value: "ktg_attorney",
          display_text: this.$t("message.contracts.document_ktg_attorney"),
        },
        {
          value: "specification",
          display_text: this.$t("message.contracts.document_specification"),
        },
        {
          value: "form_m",
          display_text: this.$t("message.contracts.form_m"),
        },
      ],
    };
  },
  mounted() {
    this.$root.$on("show-loading", () => {
      this.loading = true;
    });
    this.$root.$on("create_document", (type) => {
      console.log("create_document", type);
      this.document_.document_type =
        this.document_types[
          this.document_types.findIndex((item) => item.value == type)
        ];
      this.document_.attis_contract_doc_type =
        this.document_types[
          this.document_types.findIndex((item) => item.value == type)
        ];
      this.navigation_name = type;
    });
    this.$root.$on("bv::hide::modal", (type) => {
      if (type == "modal-document-new") {
        if (this.navigation_name !== "")
          this.$root.$emit(
            "trigger_navigation",
            "after-" + this.navigation_name,
          );
      }
    });
    this.loadExistingDocuments()
    // this.document_ = this.document
    // var doct = {value: '', display_text: ''}
    // this.document_types.forEach(item=>{
    // if(item.value == this.document.document_type)
    // doct = item
    // })
    // this.document_.document_type = doct
  },
  watch: {
    document_: {
      deep: true,
      handler(){
        if(this.document_.attis_contract_doc_type.value=='form_m'){
          this.$router.push({
            name: 'document-viewer',
            params: {
              type: 'form_m',
              id: 'new',
              parent: this.$route.params.id
            }
          })
        }
      }
    }
  },
  methods: {
    /**
     * Loads list of existing documents for this pre-contract
     */
    loadExistingDocuments(){
      axios
        .get(
          window.base +
            "/document?attis_contract_id=" +
            this.contract_details.attis_contract_id
        )
        .then((response) => {
          this.documents = response.data;
        });
    },
    unify_doctypes(doctype) {
      switch (doctype) {
        case "invoice":
        case "Инвойс":
          return "invoice";
        case "epi":
        case "ЭПИ":
          return "epi";
        case "fm1":
        case "ФМ-1":
          return "fm1";
        case "awb":
        case "AWB":
        case "АВБ":
          return "awb";
        case "rwb":
        case "RWB":
        case "Железнодорожная накладная":
          return "rwb";
        case "packaging":
        case "Пакинг лист":
          return "packaging";
        case "insurance":
        case "Страховка":
        case "страховка":
        case "Insurance":
          return "insurance";
        case "liability-insurance":
        case "Cтраховка ответственности":
        case "liability-insurance":
          return "liability-insurance";
        case "ktg_attorney":
        case "Доверенность КТЖ":
        case "KTZ power of attorney":
          return "ktg_attorney";
        default:
          return "";
      }
    },
    upload_files() {
      for (let i = this.files_att.length - 1; i >= 0; i--) {
        var fd = new FormData();
        this.files_loading = true;
        fd.append("Files[0]", this.files_att[i]);
        axios
          .post(
            window.base +
              "/document/UploadFile?docid=" +
              this.contract_details.attis_contract_id +
              "&type=" +
              this.unify_doctypes(this.document_.attis_contract_doc_type.value),
            fd,
            { headers: { "Content-Type": "multipart/form-data" } },
          )
          .then((response) => {
            this.files.push(response.data);
            this.files_att.splice(i, 1);
            this.files_loading = false;
          });
      }
    },
    file_link(file) {
      return window.base + "/document/getfile/" + file.ID;
    },
    addAttachement() {
      this.files_att.push("");
    },
    attachFile(event, index) {
      if (typeof event.target.files[0] !== "undefined")
        this.files_att[index] = event.target.files[0];
    },
    removeFile1(index) {
      this.files_att.splice(index, 1);
    },
    removeFileUploaded(index) {
      this.files.splice(index, 1);
    },
    fileSelected(event) {
      if (typeof event.target.files[0] !== "undefined") {
        console.log(event.target.files[0]);
        if (event.target.files[0].size / 1000000 < 20)
          this.$set(this.document_, "file", event.target.files[0]);
        else {
          new Noty({
            theme: "light",
            type: "error",
            text: this.$t("message.contracts.file_too_big20"),
            timeout: 5000,
          }).show();
          document.querySelector("#document_file").value = "";
        }
      } else this.document_.file = false;
    },
    docTypeFocused() {
      this.document_types_focused = true;
    },
    docTypeBlurred() {
      this.document_types_focused = false;
    },
    removeFile() {
      this.document_.file = "";
    },
    saveDocument() {
      this.$root.$emit("saveDocument", {
        document: this.document_,
        contract: this.contract_details,
      });
      
      // this.$root.$emit('bv::hide::modal', 'modal-document', '#btnShow')
    },
    cancel() {
      this.$bvModal
        .msgBoxConfirm(this.$t("message.contracts.document_cancel_message"), {
          title: this.$t("message.confirm"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: this.$t("message.yes"),
          cancelTitle: this.$t("message.no"),
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value)
            this.$root.$emit(
              "bv::hide::modal",
              "modal-document-new",
              "#btnShow",
            );
        })
        .catch((err) => {
          // An error occurred
        });
    },
  },
  computed: {
    user_role(){
      return this.$store.state.user.role || 'importer'
    },
    filtered_document_types(){
      if(this.user_role=='importer'){
        const documents_list = [
          {value: 'specification', display_text: 'Specification'},
          {value: 'invoice', display_text: 'Proforma Invoice'},
          {value: 'bol', display_text: 'BoL'}
        ]
        if(this.documents.length<3){
          return [documents_list[this.documents.length]]
        }
        return []
      }
    },
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
      }
      return locale;
    },
  },
};
</script>
